import { Button } from "components/Button/Button";
import { CheckableButton } from "components/CheckableButton/CheckableButton";
import { RangeSlider } from "components/RangeSlider/RangeSlider";
import { Textbox } from "components/Textbox/Textbox";
import { useEffect, useState } from "react";
import { getRate, putCustomerFeedBack } from "./api";
import { Message } from "components/Message/Message";
import { trans } from "utils/helpers";


interface props {
    mode?: any
    hide?: () => void
    reload?: () => void
    Id?:any

}

export const CustomerFeedBackForm = ({ mode="create", hide,reload  , Id}:props) => {
    const [serviceRequest, setServiceRequest] = useState<any>(true);
    const [rateRange, setRateRange] = useState<any>();
    const [resetForm, setResetForm] = useState<boolean>(false);

    const handleSubmit = (event) => {
        event.preventDefault()
        if (mode == "edit") {
          let IsDelive = serviceRequest ;
          let CustomerFeedBackRate  = event.target.progressbar.value ;
          let CustomerFeedBackDescription = event.target.Description.value ;
          sendDataAsync(Id,IsDelive,CustomerFeedBackRate,CustomerFeedBackDescription)
         //notWork

          } else {
            let IsDelive = serviceRequest`` ;
            let CustomerFeedBackRate  = event.target.progressbar.value ;
            let CustomerFeedBackDescription = event.target.Description.value ;
            sendDataAsync(Id,IsDelive,CustomerFeedBackRate,CustomerFeedBackDescription)
        }

    }


    async function sendDataAsync(Id,IsDelive,CustomerFeedBackRate,CustomerFeedBackDescription) {
        try {

          let res = await putCustomerFeedBack(Id,IsDelive,CustomerFeedBackRate,CustomerFeedBackDescription );
          hide && hide();
          reload && reload()
        }catch (err: any) {


         }
      }

    async function getRateAsync() {
        try {
          const res = await getRate( );
          setRateRange(res?.Data)
          
        } catch (err: any) {


         }
      }

      useEffect(() => {
        getRateAsync();
        if (Id){
        } 
      }, [Id]);




    return (
     <form onSubmit={handleSubmit}>
       <div className="m-2">        
            <div className="card">
                <div className="card-body">
                  <Message message={trans("Msg_RateOurServices")} type={"info"} />
                <div className="row">
                <div className="col-2 mt-4">
                    <CheckableButton
                      onchange={(e) =>
                        e && setServiceRequest(true)
                      }
                      defaultChecked={serviceRequest == true?true:false}
                      labelText={"ok"}
                      inputName={"confirm"}
                      type="radio"
                    />
                  </div>  
                  <div className="col-2 mt-4 ">
                                      <CheckableButton
                                         onchange={(e) =>
                                          e && setServiceRequest(false)
                                        }
                                        defaultChecked={serviceRequest == false?true:false}
                                        labelText={"decline"}
                                        inputName={"confirm"}
                                        type="radio"
                                      />
                                    </div>      
                  <div className="col mt-3 pb-4 pr-0">
                    <RangeSlider Range={rateRange} required={true} type={"icon"} mode={mode} label="Satisfaction" defaultValue={serviceRequest?.Progress} name="progressbar" resetForm={resetForm} />
                  </div>
                  </div>
                 <div className="row">
                    <div className="col-10 col-sm-10">
                        <Textbox
                            textboxType="textarea"
                            textboxName="Description"
                            labelText="Description"
                            required={!serviceRequest}
                            autoFocus={true}
                            mode={mode}
                            resetForm={resetForm}
                            defaultValue={''}
                        />
                    </div>
                 </div>
                    <div className="row">
                        {mode != "view" ? (
                          <div className="d-flex justify-content-end">
                                <Button btnType="submit" value="save" />
                                <Button
                                    btnType="cancel"
                                    value="cancel"
                                    onClick={() => {hide && hide()}}
                                    />
                            </div>
                            ) : (<></>)
                           }
                    </div>
                </div>
              </div>

             </div>
            </form>
    )
}